import { effect, inject, Injectable, signal } from '@angular/core';
import { OrderSelectedCustomization } from '../../../../../../models/order/api-models/order-pd-response.model';
import { OrderStateServiceV2 } from '../../order-state.service';
import { OrderFlowType, OrderV2 } from '../../../../../../models/order/order.model';
import { OrderCustomizationSubPayload } from '../../../../../../models/order/workflow/order-customization.model';
import { OrderInternetCustomizationsStateService } from './order-internet-customization.state.service';
import { OrderWirelessCustomizationsStateService } from './order-wireless-customization.state.service';
import { OrderVideoCustomizationsStateService } from './order-video-customization.state.service';
import { OrderVoiceCustomizationsStateService } from './order-voice-customization.state.service';



@Injectable({ providedIn: 'root' })
export class OrderCustomizationsStateService {
    private orderStateService = inject(OrderStateServiceV2);
    private internetCustomizationStateService = inject(OrderInternetCustomizationsStateService);
    private wirelessCustomizationStateService = inject(OrderWirelessCustomizationsStateService);
    private videoCustomizationStateService = inject(OrderVideoCustomizationsStateService);
    private voiceCustomizationStateService = inject(OrderVoiceCustomizationsStateService);

    selectedCustomizations = signal<OrderSelectedCustomization[]>([]);

    constructor() {
        effect(() => {
            const order = this.orderStateService.order();
            const internetCustomization = this.internetCustomizationStateService.selectedCustomizations();
            const wirelessCustomization = this.wirelessCustomizationStateService.selectedCustomizations();
            const videoCustomization = this.videoCustomizationStateService.selectedCustomizations();
            const voiceCustomization = this.voiceCustomizationStateService.selectedCustomizations();
            if (order && (internetCustomization || wirelessCustomization || videoCustomization || voiceCustomization)) {
                this.setupSelectedCustomizations(order);
            }
        });
    }

    private setupSelectedCustomizations(order: OrderV2) {
        if (order) {
            const selectedCustomizations = [];
            selectedCustomizations.push(...this.internetCustomizationStateService.selectedCustomizations());
            selectedCustomizations.push(...this.wirelessCustomizationStateService.selectedCustomizations());
            selectedCustomizations.push(...this.videoCustomizationStateService.selectedCustomizations());
            selectedCustomizations.push(...this.voiceCustomizationStateService.selectedCustomizations());
            selectedCustomizations.sort((a, b) => (a.choice?.CartSeq || 0) - (b.choice?.CartSeq || 0));
            this.selectedCustomizations.set(selectedCustomizations);
        }
    }

    buildInternetCustomizationPayload(): OrderCustomizationSubPayload[] {
        return this.internetCustomizationStateService.buildCustomizationPayload();
    }

    buildWirelessCustomizationPayload(): OrderCustomizationSubPayload[] | null {
        return this.wirelessCustomizationStateService.buildCustomizationPayload();
    }

    buildVideoCustomizationPayload(): OrderCustomizationSubPayload[] | null {
        return this.videoCustomizationStateService.buildCustomizationPayload();
    }

    buildVoiceCustomizationPayload(): OrderCustomizationSubPayload[] | null {
        return this.voiceCustomizationStateService.buildCustomizationPayload();
    }

    findSelectedCustomizationByChoiceCode(choiceCode: string): OrderSelectedCustomization | undefined {
        return this.selectedCustomizations().find(cust => cust.choice?.ChoiceCode === choiceCode);
    }

    findSelectedCustomizationsByTypeAndChoiceCode(type: OrderFlowType, choiceCode: string): OrderSelectedCustomization[] {
        return this.selectedCustomizations().filter(cust => cust.type === type && cust.choice?.ChoiceCode === choiceCode);
    }
}